var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-266 -3294)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(266 3294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(281.502 3308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.426,281.6a2.458,2.458,0,0,1-.246,1.885,2.521,2.521,0,0,1-.524.637H92.789a2.521,2.521,0,0,1-.524-.637,2.458,2.458,0,0,1-.246-1.885l.6-2.2H89.282V272.38c0-.112,0-.222-.01-.332a8.446,8.446,0,0,0,6.78-3.513,2.38,2.38,0,0,1-.953.2,2.286,2.286,0,0,1-2.291-2.12,4.653,4.653,0,0,1-4.848,1.549c-.043-.012-.332-.183-.761-.418a8.29,8.29,0,0,1-4.668,1.431H80.063a8.291,8.291,0,0,1-4.72-1.467,6.1,6.1,0,0,0-2.179,4.671v7.026H69.83Zm9.884-3.113a2.3,2.3,0,0,1,1.05-1.21l.008,0,1.438-1.338a.649.649,0,0,1,.917.029l.135.144a.649.649,0,0,1-.03.916l-.221.207.111.042,1.681.625a.6.6,0,0,1,.351.765l-.063.171a.6.6,0,0,1-.766.351l-1.549-.576-.093.249,1.875.7a.6.6,0,0,1,.351.766l-.063.171a.6.6,0,0,1-.766.351l-1.875-.7-.093.249,1.549.576a.6.6,0,0,1,.351.766l-.063.171a.6.6,0,0,1-.558.388.591.591,0,0,1-.207-.038l-2.048-.762A2.356,2.356,0,0,1,80.31,278.491Zm0,0",
    transform: "translate(-64.025 -246.825)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.244,299.358h-2.467a8.348,8.348,0,0,1-1.531-.141,2.845,2.845,0,0,0,5.537,0,8.363,8.363,0,0,1-1.539.143Zm0,0",
    transform: "translate(-174.739 -277.007)",
    fill: "#ffbf9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.045,299.376h-.269a8.351,8.351,0,0,1-1.531-.141,2.83,2.83,0,0,0,2.768,2.19,2.865,2.865,0,0,0,.882-.139A2.824,2.824,0,0,1,191.045,299.376Zm0,0",
    transform: "translate(-174.739 -277.025)",
    fill: "#ffbf9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.254,147.689v-3.4h-.749a1.961,1.961,0,0,0-1.962,1.949v1.629a1.961,1.961,0,0,0,1.962,1.949h1.03a8.158,8.158,0,0,1-.281-2.127Zm0,0",
    transform: "translate(-56.514 -133.579)",
    fill: "#ffd4be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.154,144.289h-.749c0,.006,0,.011,0,.017v3.384a8.174,8.174,0,0,1-.281,2.127h1.03a1.961,1.961,0,0,0,1.962-1.949v-1.629A1.961,1.961,0,0,0,352.154,144.289Zm0,0",
    transform: "translate(-324.603 -133.58)",
    fill: "#ffd4be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.039,56.7,111,56.62l-.065-.136-.074.076c-1.537,1.584-3.626,3.473-4.854,3.473a.617.617,0,0,1-.565-.242c-.279-.445.155-1.357.159-1.366l-.116-.088c-.019.017-1.935,1.676-3.283,1.676a1.264,1.264,0,0,1-.475-.085c-.5-.2-.768-.46-.807-.771-.081-.636.814-1.306.823-1.313l-.081-.124a17.909,17.909,0,0,1-3.784,1.649,8.6,8.6,0,0,0-.807,3.648V66.4a8.343,8.343,0,0,0,8.372,8.315h2.467a8.343,8.343,0,0,0,8.372-8.315V63.018a8.631,8.631,0,0,0-.353-2.448,6.738,6.738,0,0,1-4.89-3.873Zm0,0",
    transform: "translate(-89.405 -52.292)",
    fill: "#ffd4be"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.979 11.171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.893,152.265a.557.557,0,0,1-.557-.557v-.64a.557.557,0,1,1,1.113,0v.64A.557.557,0,0,1,153.893,152.265Zm0,0",
    transform: "translate(-151.336 -150.512)",
    fill: "#775436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2,152.265a.557.557,0,0,1-.557-.557v-.64a.557.557,0,1,1,1.113,0v.64A.557.557,0,0,1,285.2,152.265Zm0,0",
    transform: "translate(-274.895 -150.512)",
    fill: "#775436"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187,223.261a3.315,3.315,0,0,1-3.166-3.44.449.449,0,0,1,.452-.446h5.427a.449.449,0,0,1,.452.446,3.315,3.315,0,0,1-3.166,3.44Zm0,0",
    transform: "translate(-169.73 -203.092)",
    fill: "#fb8276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.192,219.822a.45.45,0,0,1,.452-.446h-2.356a.449.449,0,0,0-.452.446,3.315,3.315,0,0,0,3.166,3.44,2.933,2.933,0,0,0,1.178-.248A3.454,3.454,0,0,1,186.192,219.822Zm0,0",
    transform: "translate(-169.73 -203.093)",
    fill: "#e1756a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.391,5.249a8.208,8.208,0,0,0-3.905-3.715c-8.751-4.5-15.155,2.1-15.834,4.513-.841,2.986,5.254-.553,5.254-.553s-1.932,1.43,0,2.212c1.366.553,3.836-1.6,3.836-1.6s-.827,1.714.473,1.714c1.246,0,3.329-1.869,4.907-3.5.019.039.037.079.057.119a6.812,6.812,0,0,0,5.669,4.018h.03a.308.308,0,0,0,.221-.095.342.342,0,0,0,.094-.262,7.676,7.676,0,0,0-.8-2.854Zm0,0",
    transform: "translate(-80.611 0)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.965,6.047C90.443,4.35,93.754.58,98.721.06,92.483-.582,88.2,4.1,87.652,6.047c-.42,1.491.889,1.355,2.3.846A1.209,1.209,0,0,1,89.965,6.047Zm0,0",
    transform: "translate(-80.611 0)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.476,405.459a2.572,2.572,0,0,1-1.843,3.153,2.61,2.61,0,0,1-3.192-1.82l-.849-3.131a2.572,2.572,0,0,1,1.843-3.153,2.61,2.61,0,0,1,3.192,1.82Zm0,0",
    transform: "translate(-0.003 -370.7)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.791,406.794l-.849-3.131a2.565,2.565,0,0,1,1.34-2.964,2.627,2.627,0,0,0-1.851-.19,2.572,2.572,0,0,0-1.843,3.153l.849,3.131a2.61,2.61,0,0,0,3.192,1.82,2.645,2.645,0,0,0,.5-.19,2.574,2.574,0,0,1-1.342-1.631Zm0,0",
    transform: "translate(0 -370.702)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.88,405.459a2.571,2.571,0,0,0,1.843,3.153,2.61,2.61,0,0,0,3.192-1.82l.849-3.131a2.572,2.572,0,0,0-1.843-3.153,2.61,2.61,0,0,0-3.192,1.82Zm0,0",
    transform: "translate(-340.957 -370.7)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.246,405.459l.85-3.132a2.575,2.575,0,0,1,1.334-1.627,2.65,2.65,0,0,0-.51-.194,2.61,2.61,0,0,0-3.192,1.82l-.85,3.132a2.572,2.572,0,0,0,1.843,3.153,2.625,2.625,0,0,0,1.858-.193,2.565,2.565,0,0,1-1.333-2.96Zm0,0",
    transform: "translate(-340.955 -370.7)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.553,345.422a.558.558,0,1,1,.393-.163A.559.559,0,0,1,218.553,345.422Zm0,0",
    transform: "translate(-201.355 -318.754)",
    fill: "#03ca8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.553,371.172a.557.557,0,1,1,.393-.163A.561.561,0,0,1,218.553,371.172Zm0,0",
    transform: "translate(-201.355 -342.593)",
    fill: "#03ca8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.1,334.168a2.289,2.289,0,0,1,.708-.981,4.6,4.6,0,0,1-3.812-4.55,1.86,1.86,0,1,0-3.719,0A8.343,8.343,0,0,0,129.149,337a2.346,2.346,0,0,1-1.053-2.836Zm0,0",
    transform: "translate(-111.811 -302.501)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.1,219.79l-.129-.129a.67.67,0,0,0-.947,0l-1.116,1.116-.083-.083,1.362-1.362a.67.67,0,0,0,0-.947l-.129-.129a.67.67,0,0,0-.947,0l-1.362,1.362-.083-.083,1.116-1.116a.669.669,0,0,0,0-.947l-.129-.129a.67.67,0,0,0-.947,0l-1.265,1.265,0,0-.059-.175a.722.722,0,0,0-.915-.455l-.187.063a.722.722,0,0,0-.455.915l.615,1.855a2.36,2.36,0,0,0,.685,1.506,2.428,2.428,0,0,0,3.433-.038l1.545-1.545A.67.67,0,0,0,378.1,219.79Zm0,0",
    transform: "translate(-343.725 -201.03)",
    fill: "#ffd4be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.793,395.141l.064-.171a.67.67,0,0,0-.394-.861l-1.48-.55.041-.11,1.805.671a.669.669,0,0,0,.861-.394l.064-.171a.669.669,0,0,0-.394-.861l-1.805-.671.041-.11,1.479.55a.67.67,0,0,0,.861-.394L216,391.9a.669.669,0,0,0-.394-.861l-1.677-.624h0l.134-.126a.722.722,0,0,0,.033-1.021l-.135-.144a.722.722,0,0,0-1.021-.032l-1.431,1.331a2.36,2.36,0,0,0-1.084,1.25,2.428,2.428,0,0,0,1.464,3.105l2.048.761a.67.67,0,0,0,.861-.394Zm0,0",
    transform: "translate(-194.205 -360.028)",
    fill: "#ffd4be"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby6);
export default __webpack_public_path__ + "static/media/baby6.8ed821e4be4c4763c103ed3103eebd41.svg";
export { ForwardRef as ReactComponent };